__turbopack_context__.v({
  "actions": "Header-module-scss-module__wuH95W__actions",
  "header": "Header-module-scss-module__wuH95W__header",
  "iconBtn": "Header-module-scss-module__wuH95W__iconBtn",
  "inner": "Header-module-scss-module__wuH95W__inner",
  "logo": "Header-module-scss-module__wuH95W__logo",
  "logoMain": "Header-module-scss-module__wuH95W__logoMain",
  "logoSub": "Header-module-scss-module__wuH95W__logoSub",
  "scrolled": "Header-module-scss-module__wuH95W__scrolled",
  "searchBar": "Header-module-scss-module__wuH95W__searchBar",
  "searchForm": "Header-module-scss-module__wuH95W__searchForm",
  "searchInput": "Header-module-scss-module__wuH95W__searchInput",
  "searchSubmit": "Header-module-scss-module__wuH95W__searchSubmit",
  "slideDown": "Header-module-scss-module__wuH95W__slideDown",
});
